<!--
 * @Descripttion: 设置字段弹框
 * @Date: 2024-12-23 16:57:37
-->
<template>
  <BaseDialog
    title="设置显示字段"
    width="960px"
    :model-value="true"
    :before-close="onCancel"
  >
    <BaseTextContent>
      <div class="biz-table-set-field-dialog">
        <BaseScrollbar class="settings-dialog-left">
          <template v-if="disabledTableColumns.length">
            <div
              v-if="disabledTableColumns.length"
              class="settings-dialog-checkbox"
              style="margin-bottom: 20px"
            >
              <div
                style="cursor: not-allowed"
                v-for="item in disabledTableColumns"
                :key="item.prop"
              >
                <BaseCheckbox
                  :key="item.prop"
                  :disabled="true"
                  :true-value="1"
                  :false-value="0"
                  v-model="item._checked"
                ></BaseCheckbox>
                <BaseToolTip
                  :content="item.label"
                  over-show
                  :enterable="false"
                  :style="overStyle"
                >
                  {{ item.label }}
                </BaseToolTip>
              </div>
            </div>
          </template>

          <p>{{ baseTitle }}</p>
          <template v-if="baseTableColumns.length">
            <div class="checkbox-all" @click="onCheckAll(baseTableColumns)">
              <BaseCheckbox
                :modelValue="checkedAllModelValue(baseTableColumns)"
                :indeterminate="indeterminateBase(baseTableColumns)"
              ></BaseCheckbox>
              全选
            </div>

            <div class="settings-dialog-checkbox">
              <div
                v-for="item in baseTableColumns"
                :key="item.prop"
                @click="onCheckboxChange(item)"
              >
                <BaseCheckbox
                  :true-value="1"
                  :false-value="0"
                  :modelValue="item._checked"
                ></BaseCheckbox>
                <BaseToolTip
                  :content="item.label"
                  over-show
                  :enterable="false"
                  :style="{
                    ...overStyle
                  }"
                >
                  {{ item.label }}
                </BaseToolTip>
              </div>
            </div>
          </template>

          <template v-if="otherTableColumns.length">
            <p style="margin-top: 20px">{{ otherTitle }}</p>
            <div class="checkbox-all" @click="onCheckAll(otherTableColumns)">
              <BaseCheckbox
                :modelValue="checkedAllModelValue(otherTableColumns)"
                :indeterminate="indeterminateBase(otherTableColumns)"
              ></BaseCheckbox>
              全选
            </div>

            <div class="settings-dialog-checkbox">
              <div
                v-for="item in otherTableColumns"
                :key="item.prop"
                @click="onCheckboxChange(item)"
              >
                <BaseCheckbox
                  :true-value="1"
                  :false-value="0"
                  :modelValue="item._checked"
                ></BaseCheckbox>
                <BaseToolTip
                  :content="item.label"
                  over-show
                  :enterable="false"
                  :style="{
                    ...overStyle
                  }"
                >
                  {{ item.label }}
                </BaseToolTip>
              </div>
            </div>
          </template>
        </BaseScrollbar>

        <div class="settings-dialog-right">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              box-sizing: border-box;
              padding: 0 20px;
            "
          >
            <p
              style="
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 14px;
                color: #121619;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
              "
            >
              已选字段（{{ checkedList.length }}）
            </p>
            <BaseButton type="text" @click="onClearCheckedList">
              清空
            </BaseButton>
          </div>
          <BaseScrollbar
            :style="{
              height: 'calc(100% - 35px)',
              boxSizing: 'border-box',
              padding: '0 20px'
            }"
          >
            <template v-if="disabledTableColumns.length">
              <div
                class="settings-dialog-item"
                style="
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #878d96;
                  line-height: 22px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                "
                v-for="item in disabledTableColumns"
                :key="item.prop"
              >
                <p>
                  <BaseToolTip
                    :content="item.label"
                    over-show
                    :enterable="false"
                    :style="overStyle"
                  >
                    {{ item.label }}
                  </BaseToolTip>
                </p>
                <p>不可排序字段</p>
              </div>
            </template>

            <Draggable
              :list="checkedList"
              :animation="200"
              handle=".itemMove"
              itemKey="prop"
              :forceFallback="true"
              ghost-class="ghost"
              @start="isDrag = true"
              @end="isDrag = false"
            >
              <template #item="{ element: item }">
                <div class="settings-dialog-item">
                  <p style="display: flex; align-items: center">
                    <BaseToolTip
                      effect="light"
                      content="长按拖动选项"
                      :enterable="false"
                      :disabled="isDrag"
                    >
                      <!-- 移动 -->
                      <span>
                        <img
                          src="https://cdn.myxrk.com/myxrk-v2/front-end/assets/oss/topic/svg/yidong.svg"
                          class="icon itemMove"
                          style="
                            cursor: move;
                            margin: -3px 10px 0 0;
                            width: 16px;
                            height: 16px;
                          "
                        />
                      </span>
                    </BaseToolTip>
                    <BaseToolTip
                      :content="item.label"
                      over-show
                      :enterable="false"
                      :style="overStyle"
                    >
                      {{ item.label }}
                    </BaseToolTip>
                  </p>
                  <BaseButton type="default" link>
                    <BaseIcon
                      style="color: #898989"
                      size="16"
                      @click="onDeleteItem(item.prop, item)"
                    >
                      <Close />
                    </BaseIcon>
                  </BaseButton>
                </div>
              </template>
            </Draggable>
          </BaseScrollbar>
        </div>
      </div>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton @click="onConfirm">确定</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import {
  withDefaults,
  defineProps,
  defineEmits,
  ref,
  onMounted,
  nextTick,
  computed
} from 'vue';
import { Close } from '@element-plus/icons-vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  BaseCheckbox,
  BaseScrollbar,
  BaseIcon,
  XrkTableProps,
  BaseToolTip
} from 'xrk-components';
import _ from 'lodash';
import Draggable from 'vuedraggable';

import { storage } from '@/utils/storage';
import { TableColumnsItem } from '../../index';
import {
  useSetTableConfig,
  getColumnsCheckedKey,
  isSkip
} from '../hooks/index';

const props = withDefaults(
  defineProps<{
    remove?: () => void;
    tableColumns: TableColumnsItem[];
    searchColumns: XrkTableProps['searchConfig']['searchColumns'];
    baseTitle: string;
    otherTitle: string;
    storeKey?: string;
  }>(),
  {
    baseTitle: '基础信息',
    otherTitle: '其他信息'
  }
);
const emits = defineEmits(['success']);

const overStyle = ref<any>({
  overflow: 'hidden',
  'text-overflow': 'ellipsis',
  '-webkit-box-orient': 'vertical',
  display: '-webkit-box',
  'line-clamp': 1,
  'white-space': 'initial',
  'word-break': 'break-all'
});

const isDrag = ref(false);
const checkedList = ref<TableColumnsItem[]>([]);
const disabledTableColumns = ref<TableColumnsItem[]>([]);
const baseTableColumns = ref<TableColumnsItem[]>([]);
const otherTableColumns = ref<TableColumnsItem[]>([]);

onMounted(() => {
  const checkedKeys = storage.get(getColumnsCheckedKey(props.storeKey));
  const _tableColumns = _.cloneDeep(props.tableColumns);
  for (let index = 0; index < _tableColumns.length; index++) {
    const item = _tableColumns[index];
    if (!item?._sign || isSkip(item)) continue;

    if (item._disabled) {
      disabledTableColumns.value.push(item);
      continue;
    }

    if (item?._sign === 'base') {
      baseTableColumns.value.push(item);
    } else if (item?._sign === 'other') {
      otherTableColumns.value.push(item);
    }

    if (checkedKeys) {
      const obj = checkedKeys.find(val => val.prop === item.prop);
      item._checked = obj ? 1 : 0;
      if (obj) {
        checkedList.value.push({
          ...item,
          _sort: obj?._sort || item._sort
        });
      }
    } else {
      if (item._checked === 1) checkedList.value.push(item);
    }
  }

  disabledTableColumns.value?.sort((a, b) => a._sort - b._sort);
  baseTableColumns.value?.sort((a, b) => a._sort - b._sort);
  otherTableColumns.value?.sort((a, b) => a._sort - b._sort);
  checkedList.value?.sort((a, b) => a._sort - b._sort);
});

const checkedAllModelValue = computed(() => {
  return columns => {
    return checkedList.value.some(item => {
      return columns.some(val => item.prop === val.prop);
    });
  };
});
const indeterminateBase = computed(() => {
  return columns => {
    const len = checkedList.value.filter(item =>
      columns.some(val => val.prop === item.prop)
    ).length;

    return len && len !== columns.length;
  };
});
const onCheckAll = columns => {
  const indeterminate = indeterminateBase.value(columns);
  const flag = !checkedAllModelValue.value(columns);

  columns.forEach(item => {
    const index = checkedList.value.findIndex(val => val.prop === item.prop);

    if (flag || indeterminate) {
      item._checked = 1;
      if (index === -1) checkedList.value.push(item);
    } else {
      item._checked = 0;
      if (index !== -1) checkedList.value.splice(index, 1);
    }
  });

  if (flag) {
    nextTick(() => {
      const el = document.querySelectorAll('.settings-dialog-item');
      el?.[el.length - 1]?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
      });
    });
  }
};
const onCheckboxChange = (item: TableColumnsItem) => {
  item._checked = !item._checked ? 1 : 0;

  if (item._checked) {
    checkedList.value.push(item);

    nextTick(() => {
      const el = document.querySelectorAll('.settings-dialog-item');
      el?.[el.length - 1]?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
      });
    });
  } else {
    const index = checkedList.value.findIndex(val => val.prop === item.prop);
    if (index !== -1) checkedList.value.splice(index, 1);
  }
};

const onClearCheckedList = () => {
  checkedList.value = [];
  baseTableColumns.value.forEach(item => {
    item._checked = 0;
  });
  otherTableColumns.value.forEach(item => {
    item._checked = 0;
  });
};
const onDeleteItem = (key: string, value: TableColumnsItem) => {
  const index = checkedList.value.findIndex(val => val.prop === key);
  if (index !== -1) checkedList.value.splice(index, 1);

  const currentObj = (
    value._sign === 'base' ? baseTableColumns.value : otherTableColumns.value
  ).find(item => item.prop === value.prop);
  if (currentObj) currentObj._checked = 0;
};

const onCancel = () => {
  props?.remove?.();
};
const onConfirm = () => {
  const startIndex = disabledTableColumns.value?.length
    ? Math.max(...disabledTableColumns.value.map(item => item._sort))
    : 0;
  const checkedKeys = checkedList.value.map((item, index) => {
    return {
      prop: item.prop,
      _sort: startIndex + index + 1
    };
  });
  const { newSearchColumns, newTableColumns } = useSetTableConfig({
    checkedKeys,
    tableColumns: props.tableColumns,
    searchColumns: props.searchColumns
  });

  storage.set(getColumnsCheckedKey(props.storeKey), checkedKeys);
  emits('success', {
    newSearchColumns,
    newTableColumns
  });
  onCancel();
};
</script>

<style lang="scss" scoped>
.biz-table-set-field-dialog {
  $baseHeight: 52vh;

  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $baseHeight;

  .settings-dialog-left {
    flex: 1;
    height: $baseHeight;
    border: 1px solid gainsboro;
    box-sizing: border-box;
    padding: 15px 20px 20px;

    .settings-dialog-checkbox {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0 16px;

      > div {
        user-select: none; /* 标准语法 */
        -webkit-user-select: none; /* Safari 和 Chrome */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE 10+ */
        cursor: pointer;
        display: flex;
        align-items: center;
        .xrk-checkbox {
          margin-top: -2px;
        }
      }
    }

    .checkbox-all {
      user-select: none; /* 标准语法 */
      -webkit-user-select: none; /* Safari 和 Chrome */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE 10+ */
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }

  .settings-dialog-right {
    width: 300px;
    margin-left: 20px;
    height: $baseHeight;
    border: 1px solid gainsboro;
    box-sizing: border-box;
    padding: 15px 0 20px;
    .settings-dialog-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
}
</style>
